import React from 'react';

import { Skeleton } from '@dashboard/components/ui/skeleton';

const COLUMNS = ['w-16', 'w-40', 'w-20', 'w-12', 'w-32', 'w-16'];

export default function ListScreenSkeleton() {
  return (
    <div aria-busy="true" aria-label="Loading">
      <div className="flex h-8 items-center justify-between gap-2">
        <Skeleton className="h-6 w-28" />
        <div className="hidden gap-2 md:flex">
          <Skeleton className="h-8 w-60" />
          <Skeleton className="h-8 w-32" />
          <Skeleton className="h-8 w-24" />
        </div>
      </div>

      <div className="mt-4 overflow-hidden rounded-lg border border-gray-200">
        <div className="flex h-[46px] items-center gap-8 px-4">
          {COLUMNS.map((width, index) => (
            <Skeleton key={index} className={`h-4 ${width}`} />
          ))}
        </div>
        {Array.from({ length: 8 }).map((_, row) => (
          <div key={row} className="flex h-[41px] items-center gap-8 border-t border-gray-200 px-4">
            {COLUMNS.map((width, index) => (
              <Skeleton key={index} className={`h-3 ${width}`} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
